export default __webpack_public_path__ + "static/media/generous.ea84c015.svg";